// B-590 · EL NOMBRE DE UN ROL, NUNCA SU CLAVE
//
// `agentes.rol` guarda la CLAVE del rol, y para un rol personalizado esa clave sale del nombre que escribió la clínica:
// «Doctor/a» se guarda como `r_doctor_a` y «Higienista» como `r_higienista`. Media aplicación pintaba la clave tal cual
// (la lista de usuarios, el menú de perfil, el chat, el control horario), así que la clínica veía «r_doctor_a» donde
// había escrito «Doctor/a». El nombre de verdad lo manda el servidor JUNTO A LOS PERMISOS (GET /api/permisos/mias,
// `_nombres_roles`, la consulta que la aplicación hace nada más entrar) y services/permisosDelServidor lo deja aquí con
// `recordarNombresRol`. Así ninguna pantalla hace una consulta más para pintar un nombre; mientras no ha llegado, los
// de serie.
//
// B-2259 · EN EL IDIOMA DE QUIEN MIRA. Los nombres de serie son nombres de fábrica (herramientas/i18n/catalogos.js los junta
// como la zona «catalogos») y salen con tDato: traducidos SOLO si siguen siendo el de fábrica; el que escribió la clínica sale
// como lo escribió. La lista se queda en castellano (hay guardias que la leen tal cual).
import { t, tDato } from './i18n.js'

// i18n-dato: los nombres de serie se traducen al devolverlos (nombreRol, abajo, con tDato).
export const NOMBRES_ROL_DE_SERIE = {
  admin: 'Administración', recepcion: 'Recepción', colaborador: 'Colaborador', auxiliar: 'Auxiliar',
  almacen: 'Almacén', limpieza: 'Limpieza', control_horario: 'Sistema de fichaje', gerente: 'Gerente',
  // t566 · de fábrica desde el 30-oct-2026 (antes, roles propios de cada clínica: r_doctor_a, r_higienista).
  doctor: 'Doctor/a', higienista: 'Higienista',
}

let nombresDelServidor = {}

// Lo llama services/permisosDelServidor con cada respuesta de /mias. SUSTITUYE (no mezcla): al cambiar de clínica, los
// roles personalizados de la anterior no se quedan.
export function recordarNombresRol(nombres) {
  if (nombres && typeof nombres === 'object' && !Array.isArray(nombres)) nombresDelServidor = { ...nombres }
}

// Nunca devuelve la clave de un rol personalizado: si su nombre aún no ha llegado (o el rol ya no existe), dice
// «Rol personalizado», que es verdad y no enseña un «r_doctor_a» a nadie.
export function nombreRol(clave, nombres) {
  if (clave === null || clave === undefined || clave === '') return ''
  const k = String(clave)
  if (nombres && typeof nombres === 'object' && nombres[k]) return tDato(String(nombres[k]))
  if (nombresDelServidor[k]) return tDato(String(nombresDelServidor[k]))
  if (NOMBRES_ROL_DE_SERIE[k]) return tDato(NOMBRES_ROL_DE_SERIE[k])
  return k.startsWith('r_') ? t('utils.nombreRol.rol_personalizado', 'Rol personalizado') : k
}
